import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, MarqueeComponentHomePage} from '../qbStrap';
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';

const Bookstores = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/outlet/BookStores/Point-of-Sale.webp",
            tag: "Point of sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Fast, hassle free billing for books & supplies",
            desc: "QueueBuster makes checkouts quick and easy, from single notebooks to full exam bundles. No more long queues or pricing confusion.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>Set different prices for new, used, and combo book sets </>,
                <>Scan barcodes or use a visual product catalog </>,
                <> Accept UPI, cash, card, and wallet payments on the spot </>,
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/BookStores/InventoryManagement.webp",
            tag: "Inventory Management ",
            icon: "/assets/outlet/BookStores/InventoryManagement.svg",
            title: "Never lose track of your stock agai",
            desc: "Stay on top of what’s in, what’s out, and what needs to be restocked. Easily manage everything from novels to stationery in one place",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>  Set alerts for low stock and fast-selling books </>,
                <>Track multiple editions, languages, and publishers</>,
                <>Know exactly what’s sitting on your shelves, and what isn’t  </>,
            ],
        },
        {
            id: 3,
            image: "/assets/outlet/BookStores/eStore.webp",
            tag: "eStore",
            icon: "/assets/outlet/BookStores/eStore.svg",
            title: "Sell books online without any drama",
            desc: "Busy parents? Students who can’t visit and want to order online? Take your bookstore online in just a few steps and never miss a sale, even on Sundays.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>Set up your online store with ease, without any hassle </>,
                <>Add books, bundles, and stationery kits with prices and pics </>,
                <>Share the link via WhatsApp or social media platforms to get orders</>,
            ],
        },
        {
            id: 4,
            image: "/assets/outlet/BookStores/Reports&Insights.webp",
            tag: "Reports & Insights",
            icon: "/assets/outlet/BookStores/Reports&Insights.svg",
            title: "Crystal clear numbers",
            desc: "From top-selling books to seasonal peaks, get 80+ detailed reports that show what’s working, and what needs tweaking in your business.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>Track sales by author, title, category, or staff </>,
                <>Measure profit margins and slow movers </>,
                <>One-click tax and GST-ready reports for peace of mind</>,
            ],
        },
        {
            id: 5,
            image: "/assets/outlet/BookStores/CRM&Loyalty-Programs.webp",
            tag: "CRM & Loyalty ",
            icon: "/assets/outlet/BookStores/CRM&Loyalty-Programs.svg",
            title: "Turn first-time buyers into loyal customers",
            desc: "From exam toppers to daily readers, build lasting relationships with tailored offers and rewards.",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF3F3",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>Segment by reader type: students, parents, book lovers </>,
                <>Offer loyalty points, discounts, or freebies</>,
                <>Remember past purchases to make great recommendations </>,
            ],
        },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    Why is QueueBuster a great fit for bookstores?
                </span>
            ),
            des: <>We understand bookstore needs inside out. From barcode-based billing and multiple pricing to expiry-less inventory and customer loyalty, we’ve got you covered whether you're a corner shop or a chain. </>,
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How does inventory tracking help?
                </span>
            ),
            des: <>You’ll know what’s in stock (and what’s about to run out). No more last-minute panic during admission season or board exam rush. You’ll even get alerts to restock bestsellers.</>,
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Can I take online orders with this?
                </span>
            ),
            des: <>Absolutely. Create a simple online store for your books and supplies. Share the link with students or parents — they can order from anywhere, anytime. </>,
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Which payment options are supported?
                </span>
            ),
            des: <>All major ones, UPI, cash, debit/credit cards, wallets. Your customers can pay however they like, fast and secure. </>,
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the loyalty feature work for bookstores?
                </span>
            ),
            des: <>Track purchases, reward regular buyers, and offer special discounts during school reopening, board exams, or book fairs. Keep them coming back for more.</>,
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   Is my data safe?
                </span>
            ),
            des: <>Totally. We use enterprise-level encryption, access controls, and automatic backups to keep your business data protected and private.</>,
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How do I get started with QueueBuster?
                </span>
            ),
            des:  <>Just download the QueueBuster app, tap “My Online Store,” and start uploading your book list. In no time, you’ll have an easy-to-use platform, where you can sell all your book stock easily.</>,
            id: 7,
            activeIndex: 0,
        },
       
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/BookStores/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span>POS Billing Software For</span> <span></span>
                                <span>&nbsp; Bookstores</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Reimagine bookstore management with QueueBuster’s intelligent POS Billing Software, your all-in-one solution for science fiction, competitive prep books, bestselling fiction, non-fiction books, and so much more. From seamless billing to real-time inventory tracking and loyal customer engagement, we streamline every chapter of your business story with elegance and ease.
                            </p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/outlet/BookStores/hero-img.webp"
                            heading={<>POS Billing Software For </>}
                            staticHeading={<> Bookstores</>}
                            description={"Reimagine bookstore management with QueueBuster’s intelligent POS Billing Software, your all-in-one solution for science fiction, competitive prep books, bestselling fiction, non-fiction books, and so much more. From seamless billing to real-time inventory tracking and loyal customer engagement, we streamline every chapter of your business story with elegance and ease."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "50%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Novel Features of QueueBuster’s Bookstore POS billing software</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={" FAQ’s for bookstore POS billing software by QueueBuster"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={" FAQ’s for bookstore POS billing software by QueueBuster"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}


export default Bookstores